import React, { Component } from 'react';
import { Button, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import ErrorMessage from '../../components/ErrorMessage';
import TopBar from '../../components/TopBar';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 20px; // Padding to avoid content sticking to edges
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 480px;
  background-color: #ffffff; // Background color for the content
  padding: 30px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); // Subtle shadow for separation
  box-sizing: border-box;
  margin-top: 20px; // Spacing between the TopBar and content
`;

const Heading = styled.h1`
  margin-top: 0;
  color: #000;
`;

const ConfirmButton = styled(Button)`
  && {
    background-color: #dc3545;
    color: white;
    margin-top: 20px;
  }
`;

const CheckboxContainer = styled.div`
  margin-top: 20px;
  text-align: left;
`;

@inject('notesStore')
@observer
class CancellationPage extends Component {
  state = {
    errorMessage: null,
    dontSendNotes: false,
  };

  handleCheckboxChange = (event) => {
    this.setState({ dontSendNotes: event.target.checked });
  };

  handleConfirmCancellation = async () => {
    try {
      await this.props.notesStore.cancelSubscription(this.state.dontSendNotes);
      window.location.hash = '/account';
    } catch (error) {
      this.setState({ errorMessage: error.message });
    }
  };

  render() {
    const { errorMessage, dontSendNotes } = this.state;

    return (
      <PageContainer>
        <TopBar />
        <ContentWrapper>
          <Heading>Confirm Cancellation</Heading>
          <Typography>
            Are you sure you want to cancel your subscription? Your emails will be sent in a year.
          </Typography>

          <CheckboxContainer>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontSendNotes}
                  onChange={this.handleCheckboxChange}
                  color="primary"
                />
              }
              label="I don't want my notes sent"
            />
          </CheckboxContainer>

          {errorMessage && <ErrorMessage message={errorMessage} />}

          <ConfirmButton
            variant="contained"
            onClick={this.handleConfirmCancellation}
          >
            Confirm Cancellation
          </ConfirmButton>
        </ContentWrapper>
      </PageContainer>
    );
  }
}

export default CancellationPage;
